// Helpers e constantes puros do Chat (extraídos de ChatPage.js para reduzir o monólito).

export const NAVY = '#0A1628';
export const GOLD = '#C6E84F';
export const EMOJIS = ['👍', '❤️', '😂', '🎉', '😮', '😢', '🙏', '🔥'];
export const inputClass =
  'w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary';

/**
 * As iniciais de um nome, para a bolha do avatar.
 *
 * SÓ LETRA E DÍGITO ENTRAM. Um autor gravado como "sistema (proposta aprovada)" — que é como a
 * Esteira registrava o evento de criação — produzia a bolha "S(" e a linha "S( sistema criou este
 * projeto", que o dono viu e mandou refazer. A origem foi corrigida no backend, mas os registros
 * antigos continuam na base: filtrar aqui é o que impede a bolha de exibir pontuação para sempre.
 */
export const iniciais = (nome) => {
  const partes = String(nome || '')
    .split(/\s+/)
    .map((p) => (p.match(/[\p{L}\p{N}]/u) || [''])[0])
    .filter(Boolean);
  if (!partes.length) return '?';
  return (partes[0] + (partes.length > 1 ? partes[partes.length - 1] : '')).toUpperCase();
};

export const corAvatar = (id) => {
  const cores = ['#0A1628', '#C6E84F', '#0f766e', '#7c3aed', '#be123c', '#b45309', '#1d4ed8', '#15803d'];
  let h = 0;
  const s = String(id || '');
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return cores[h % cores.length];
};

export const fmtHora = (iso) => {
  try { return new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }); }
  catch { return ''; }
};

export const fmtDataLabel = (iso) => {
  try {
    const d = new Date(iso); const hoje = new Date(); const ontem = new Date(); ontem.setDate(hoje.getDate() - 1);
    const eq = (a, b) => a.toDateString() === b.toDateString();
    if (eq(d, hoje)) return 'Hoje';
    if (eq(d, ontem)) return 'Ontem';
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
  } catch { return ''; }
};

export const fmtTamanho = (bytes) => {
  if (!bytes) return '';
  const u = ['B', 'KB', 'MB', 'GB']; let i = 0; let n = bytes;
  while (n >= 1024 && i < u.length - 1) { n /= 1024; i++; }
  return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${u[i]}`;
};

/** Insere/atualiza a mensagem reconciliando o otimista pelo client_msg_id e
 *  evitando duplicatas pelo id (idempotência ponta-a-ponta com o backend). */
export const mergeMensagem = (prev, doc) => {
  if (!doc) return prev;
  const idx = prev.findIndex((m) =>
    (doc.client_msg_id && m.client_msg_id && m.client_msg_id === doc.client_msg_id) || m.id === doc.id);
  if (idx >= 0) {
    const copy = prev.slice();
    copy[idx] = { ...prev[idx], ...doc, _status: 'enviado' };
    return copy;
  }
  return [...prev, doc];
};

/** Resolve os tokens @nome do texto para IDs de usuário (1º nome, case-insensitive),
 *  restritos aos membros do canal. Usado para notificar quem foi mencionado. */
export const resolverMencoes = (txt, usuarios, canal) => {
  const tokens = (txt.match(/@(\w+)/g) || []).map((s) => s.slice(1).toLowerCase());
  if (!tokens.length) return [];
  const ids = (canal && canal.membros_ids) || [];
  const membros = ids.length ? usuarios.filter((u) => ids.includes(u.id)) : usuarios;
  const out = new Set();
  for (const u of membros) {
    const primeiro = (u.name || '').split(/\s+/)[0].toLowerCase();
    if (primeiro && tokens.includes(primeiro)) out.add(u.id);
  }
  return [...out];
};
